import './TQConnectTopContributors.scss';

import moment from 'moment';

import Header from '../../../../components/Header/Header';
import Loader from '../../../../components/V2/Loader/Loader';
import {
  useTQConnectTopContributors,
} from '../../../../hooks/queries/tqConnectQueries/service-requests';
import {
  useAppNavigate,
  useAppSelector,
} from '../../../../shared/hooks';
import { Onboarding } from '../../../../types/userTypes';
import type {
  TopContributorCardProps,
} from './TopContributorCard/TopContributorCard';
import TopContributorCard from './TopContributorCard/TopContributorCard';

export interface TopContributorItem extends Omit<
  TopContributorCardProps,
  'isCurrentUser' | 'performanceMessage'
> {
  id: string;
  isCurrentUser?: boolean;
  performanceMessage?: string;
}

const TQConnectTopContributors: React.FC = () => {
  const userDetails = useAppSelector((state) => state.user);
  const {
    data: topContributorsResult,
    isLoading,
    dataUpdatedAt: topContributorsLastRefreshedAt,
  } = useTQConnectTopContributors();
  const navigate = useAppNavigate();

  const handleBack = () => {
    navigate.goBack();
  };

  return (
    <div className="tq-connect-top-contributors">
      <Header
        title="Top Contributors"
        customTitle={
          <div className="tq-connect-top-contributors__title-container">
            <div className="tq-connect-top-contributors__title">
              Top Contributors
            </div>
            <div className="tq-connect-top-contributors__subtitle">
              Last refreshed at{' '}
              {moment(topContributorsLastRefreshedAt).fromNow()}
            </div>
          </div>
        }
        handleBack={handleBack}
      />
      {isLoading ? (
        <div className="tq-connect-top-contributors__loading">
          <Loader />
        </div>
      ) : (
        <div className="tq-connect-top-contributors__list">
          {topContributorsResult?.data.map((item) => (
            <TopContributorCard
              userId={item._id}
              key={item._id}
              rank={item.rank}
              name={item.name}
              avatarUrl={item.profilePicUrl}
              score={item.tqConnectScore}
              isCurrentUser={item._id === userDetails?.id}
            />
          ))}
          {userDetails?.type === Onboarding.FAN_COMPLETED &&
            topContributorsResult?.myRank &&
            topContributorsResult?.myRank > 5 && (
              <TopContributorCard
                userId={userDetails?.id ?? ''}
                rank={topContributorsResult.myRank}
                name={userDetails?.name ?? ''}
                avatarUrl={userDetails?.profilePic ?? ''}
                score={userDetails?.tqConnectScore ?? 0}
                isCurrentUser={true}
                performanceMessage={
                  topContributorsResult.youAreDoingBetterThanXPercentUsers
                }
              />
            )}
        </div>
      )}
    </div>
  );
};

export default TQConnectTopContributors;
